var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/24/social_instagram"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6364 22H8.36364C4.85924 22 2 19.1408 2 15.6364V8.36364C2 4.85924 4.85924 2 8.36364 2H15.6364C19.1408 2 22 4.85924 22 8.36364V15.6364C22 19.1408 19.1408 22 15.6364 22ZM8.36364 3.4956C5.68035 3.4956 3.51026 5.68035 3.51026 8.34897V15.6217C3.51026 18.305 5.69502 20.4751 8.36364 20.4751H15.6364C18.3196 20.4751 20.4897 18.2903 20.4897 15.6217V8.34897C20.4897 5.66569 18.305 3.4956 15.6364 3.4956H8.36364Z",
    fill: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.8974C9.40469 16.8974 7.30792 14.7859 7.30792 12.2053C7.30792 9.62463 9.41936 7.5132 12 7.5132C14.5806 7.5132 16.6921 9.62463 16.6921 12.2053C16.6921 14.7859 14.5806 16.8974 12 16.8974ZM12 9.0088C10.2405 9.0088 8.80352 10.4457 8.80352 12.2053C8.80352 13.9648 10.2405 15.4018 12 15.4018C13.7595 15.4018 15.1965 13.9648 15.1965 12.2053C15.1965 10.4457 13.7595 9.0088 12 9.0088Z",
    fill: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9707 8.15836C17.5861 8.15836 18.085 7.65944 18.085 7.04399C18.085 6.42854 17.5861 5.92962 16.9707 5.92962C16.3552 5.92962 15.8563 6.42854 15.8563 7.04399C15.8563 7.65944 16.3552 8.15836 16.9707 8.15836Z",
    fill: "#0C0C0C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialInstagram);
export default __webpack_public_path__ + "static/media/social_instagram.6710ce901cd1a28a6cfa19390f202b79.svg";
export { ForwardRef as ReactComponent };